module.exports = __webpack_public_path__ + "img/home-active.407b22cd.svg";